/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useMigrationTkStore = defineStore("migrationtk", {
  actions: {
    async mgtListFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "pawnDate",
        },
        filter: {
          fromDate:payload.fromDate,  // pawnDate
          toDate:payload.toDate,  // pawnDate
          tkRefNumber: payload.tkRefNumber,
          tkCusUid: payload.tkCusUid
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/mgt/ticket/list";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },


    async mgtInfoFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/mgt/ticket/info/" + payload.uid;
          const response = http.get(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async mgtAddFetch(payload) {
      const body = {
        tkVolNo: payload.tkVolNo,
        tkNo: payload.tkNo,
        txType: payload.txType, // PAWN, INTEREST, DEC_PRINCIPLE, INC_PRINCIPLE
        tkRefNumber: payload.tkRefNumber,
        pawnDate:  payload.pawnDate,
        pawnValue:  payload.pawnValue,
        fullValue:  payload.fullValue,
        interest:  payload.interest,
        dueDate: payload.dueDate,
        quantity: payload.quantity,
        prevTkVolNo: payload.prevTkVolNo,
        prevTkNo: payload.prevTkNo,
        tkCusUid: payload.tkCusUid,
        tkCusName: payload.tkCusName,
        collaterals: payload.collaterals,
        images:payload.images,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/mgt/ticket/new";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async mgtUpdateFetch(payload) {
      const body = {
        uid: payload.uid,
        tkVolNo: payload.tkVolNo,
        tkNo: payload.tkNo,
        txType: payload.txType, // PAWN, INTEREST, DEC_PRINCIPLE, INC_PRINCIPLE
        tkRefNumber: payload.tkRefNumber,
        pawnDate:  payload.pawnDate,
        pawnValue:  payload.pawnValue,
        fullValue:  payload.fullValue,
        interest:  payload.interest,
        dueDate: payload.dueDate,
        quantity: payload.quantity,
        prevTkVolNo: payload.prevTkVolNo,
        prevTkNo: payload.prevTkNo,
        tkCusUid: payload.tkCusUid,
        tkCusName: payload.tkCusName,
        version: payload.version,
        collaterals: payload.collaterals,
        images:payload.images,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/mgt/ticket/update";
          const response = http.put(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async mgtDeleteFetch(payload) {
      const body = {
        uid: payload.uid,
        version: payload.version,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/mgt/ticket/delete";
          const response = http.put(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

  
   },
});